// Documentacion > https://router.vuejs.org/guide/essentials/navigation.html
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Example from '../views/Example.vue'
import TransportChain from '../views/TransportChain.vue'
import ColdChainResults from '../views/ColdChainResults'
import PageNotFound from '../views/PageNotFound.vue'
import DragAndDropTimeLine from '../views/DragAndDropTimeLine.vue'
import ReportColdChain from '../views/ReportColdChain.vue'
import SlideShow from '../views/SlideShow.vue'
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/example',
    name: 'Example',
    component: Example
  },
  {
    path: '/cadena-de-frio',
    name: 'DragAndDropTimeLine',
    component: DragAndDropTimeLine
  },
  {
    path: '/resultado-cadena-de-frio',
    name: 'ColdChainResults',
    component: ColdChainResults
  },
  {
    path: '/cadena-de-transporte',
    name: 'TransportChain',
    component: TransportChain
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    component: PageNotFound
  },
  {
    path: '/reporte-cadena-de-frio',
    name: 'ReportColdChain',
    component: ReportColdChain
  },
  {
    path: '/informativo-cadena-de-frio',
    name: 'SlideShow',
    component: SlideShow
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
